<script>
import { nlToBr } from '@utils'
import formatDate, { dateDiffInMinutes } from '@utils/format-date'

export default {
  filters: {
    formatDate,
    nlToBr,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    selectQty: {
      type: Number,
      default: 0,
    },
    maxQty: {
      type: Number,
      required: true,
    },
  },
  computed: {
    handleParamMaxQty() {
      return this.stock > this.maxQty ? this.maxQty : this.stock
    },
    stock() {
      return this.data.infinity ? 9999 : this.data.inventory - this.data.qty - (this.data.selectQty || 0);
    },
    unPublish() {
      const startDateDiff = this.data.saleStartDate
        ? dateDiffInMinutes(formatDate(new Date(), 'dateTimeSecond'), `${this.data.saleStartDate}`)
        : -1;
      const endDateDiff = this.data.saleEndDate
        ? dateDiffInMinutes(formatDate(new Date(), 'dateTimeSecond'), `${this.data.saleEndDate}`)
        : 1;

      console.log('startDateDiff', startDateDiff);
      console.log('endDateDiff', endDateDiff);

      return startDateDiff > 0 || endDateDiff < 0
    },
  },
  mounted() {
    // this.$emit('change', this.selectQty)
  },
  methods: {
    onInput(value) {
      this.$emit('change', value)
    },
    formatText(type, data = {}) {
      switch (type) {
        case 'stock':
          const max = 100;
          const infinity = this.data.infinity;

          if(infinity) {
            return `無限庫存`
          }else if (this.stock > max) {
            return `剩餘${max}+`
          }else if (this.stock <= 0) {
            return '已售完'
          }else {
            return `剩餘${ this.stock }份`
          }
        case 'startSale':
          return formatDate(new Date(data.date.replace(/-/g, '/')), 'dateSlash');
        case 'endSale':
          return data.date
            ? `至${formatDate(new Date(data.date.replace(/-/g, '/')), 'dateSlash')}`
            : '';
        default:
            return ''
      }
    }
  },
}
</script>

<template>
  <div
    :class="[$style.wrapper, { [$style.isUnPublish]: unPublish, [$style.isDisabled]: unPublish || data.stock === 0 }]"
    :data-max="handleParamMaxQty"
  >
    <div :class="$style.column">
      <div :class="$style.column">
        <div style="margin-bottom: 0.5rem; display:flex">
          <b-tag
            :type="stock <= 0 ? 'is-style-disabled' : 'is-style-red'"
            style="margin-right: 0.5rem"
            rounded
          >
            {{ formatText('stock') }}
          </b-tag>
          <b-tag
            v-if="data.canAutoRenew"
            :type="'is-style-canAutoRenew'"
            rounded
          >
            {{ $t(`global.CAN_AUTO_RENEW`) }}
          </b-tag>
        </div>
        <div :class="$style.title">{{ data.name }}</div>
        <div :class="$style.subtitle">{{ data.introtext }}</div>
        <div :class="$style.subtitle">
          {{ $t(`product.${$route.params.productType}.OPEN_TIME`) }} {{ formatText('startSale', { date: data.saleStartDate }) }}
          <span>{{ formatText('endSale', { date: data.saleEndDate }) }}</span>
        </div>
      </div>
      <div
        :class="[$style.column, $style.columnText]"
        class="is-text-content"
        v-html="$options.filters.nlToBr(data.description)"
      ></div>
      <div :class="[$style.column, $style.price]">
        <span
          v-if="data.basePrice > data.price"
          :class="$style.basePrice"
        >
          ${{ data.basePrice }}
        </span>
        <br v-if="data.basePrice > data.price" />
        <template>
          <span v-if="data.price === 0">{{$t('global.FREE')}}</span>
          <span v-else>${{ data.price }}</span>
        </template>
      </div>
    </div>
    <div :class="$style.column">
      <b-numberinput
        :value="selectQty"
        :max="unPublish ? 0 : handleParamMaxQty"
        :editable="false"
        min="0"
        type="is-primary"
        controls-position="compact"
        expanded
        :class="{ 'is-zero': selectQty === 0 }"
        @input="onInput"
      ></b-numberinput>
    </div>
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;

  @include mobile {
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 1rem;
  }
  &:not(:last-child) {
    border-bottom: 1px solid $color-border-base;
  }
  &.isDisabled {
    pointer-events: none;
    .title {
      color: #afb4b5;
    }
    .columnText {
      color: #afb4b5;
    }
    .price {
      color: #afb4b5;
    }
  }
  &.isUnPublish {
    .subtitle {
      color: $color-primary;
    }
  }
  .column {
    padding: 0.75rem 0;

    @include tablet {
      &:not(:first-child) {
        padding: 0 1rem;
      }
    }

    @include mobile {
      padding: 0.5rem 0;
    }
  }

  > .column {
    &:first-child {
      display: flex;
      flex: 3;
      align-items: center;

      @include mobile {
        flex: 2;
        flex-direction: column;
        align-items: flex-start;
        padding-right: 0.5rem;
      }
      > .column {
        flex: 1;
        &.columnText {
          flex: 2 0 0;
          text-align: justify;
          margin-left: 1.5rem;
          @include mobile {
            margin-left: 0;
          }
        }
      }
    }
    &:last-child {
      flex: 1;
    }
  }
  .title {
    @extend %typography-medium;

    margin-bottom: 2px;
    font-size: 18px;
    line-height: 18px;
    color: $color-text-inner-title;
    letter-spacing: 0.45px;
  }
  .subtitle {
    font-size: 13px;
    line-height: 18px;
    color: $color-text-regular;
    letter-spacing: 0;
  }
  .price {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    .basePrice{
      font-size: 14px;
      color: #afb4b5;
      text-decoration: line-through;
    }
  }
}
</style>
